// Return Cloudinary URL for where to store attachments on posts or comments

function getDiscussionAttachmentUploadPath(communityId, attachableType) {
  return `/community/${communityId}/schools/discussions/attachments/${attachableType}`
}

export default getDiscussionAttachmentUploadPath
